import { AnalyzerControl } from "../../analyzer-control";
import { BaseControlButton } from "../base-control-button";
import './ac-mhz-btn.css';

export class ACMhzBtn extends BaseControlButton {
  private static instance_: ACMhzBtn;
  private readonly analyzerControl: AnalyzerControl;

  private constructor(analyzerControl: AnalyzerControl) {
    super({
      uniqueId: 'ac-mhz-btn',
      classNames: 'physical-button unit-button',
      subtext: 'dBm',
      label: 'MHz',
      ariaLabel: 'MHz',
    });
    if (analyzerControl) {
      this.analyzerControl = analyzerControl;
    }
  }

  static create(analyzerControl: AnalyzerControl): ACMhzBtn {
    this.instance_ = new ACMhzBtn(analyzerControl);
    return this.instance_;
  }

  static getInstance(): ACMhzBtn {
    return this.instance_;
  }

  protected handleClick_(): void {
    const currentUnit = this.analyzerControl.specA.state.inputUnit;
    if (currentUnit !== 'MHz') {
      this.analyzerControl.specA.state.inputUnit = 'MHz';

      // Convert the value to GHz if necessary
      const currentInputValue = parseFloat(this.analyzerControl.specA.state.inputValue);
      if (currentUnit === 'Hz') {
        this.analyzerControl.specA.state.inputValue = (currentInputValue / 1e6).toString();
      } else if (currentUnit === 'kHz') {
        this.analyzerControl.specA.state.inputValue = (currentInputValue / 1e3).toString();
      } else if (currentUnit === 'GHz') {
        this.analyzerControl.specA.state.inputValue = (currentInputValue * 1e3).toString();
      }

      this.analyzerControl.specA.syncDomWithState();
    }
  }
}
